import React, { useState,useEffect } from 'react';
import { Card, CardContent, Typography, Grid, TextField, Button, FormControl,Box, CircularProgress } from '@mui/material';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useFormikContext } from 'formik';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import {  IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useAuth } from '../../../AuthProvider';
import { fontWeight } from '@mui/system';
import { useParams } from 'react-router-dom';

const baseUrl=process.env.REACT_APP_API_BASE_URL
export default function StudentFeeConcessionForm() {
  const [loading, setLoading] = useState(false);
  // const { values, setFieldValue } = useFormikContext();
  const navigate = useNavigate();
  const {oId,board,pId}=useAuth();

    const { studentId } = useParams();

  const [initialValues, setInitialValues] = useState({
  studentId: "",
  requestedConcessionAmount: "",
  firstName: "",
  lastName: "",
  fathersFirstName: "",
  fathersLastName: "",
  fathersMailId: "",
  primaryContact: "",
  course: "",
  romanNumberClass: "",
  sections: "",
  tutionFee: "",
});

  const handleYearChange = (selectedYear) => {
    if (selectedYear) {
      const year = selectedYear.getFullYear(); // Extract the selected year
      const yearRange = `${year}-${year + 1}`; // Create the academic year range
      // setFieldValue('academicYear', yearRange); // Update Formik's value
    }
  };

  // Validation schema with Yup
  const validationSchema = Yup.object({
    // admissionId: Yup.string()
    //   .matches(/^\d+$/, "Admission number must be numeric")
    //   .required("Admission number is required"),
      // surName: Yup.string().required("surname is required"),
    // firstName: Yup.string().required("First name is required"),
    // lastName: Yup.string().required("Last name is required"),
    fathersMailId: Yup.string().email("Email is invalid"),
    // .required("Email address is required"),
    primaryContact: Yup.string().matches(/^\d{12}$/, "Phone number must be 10 digits").required("Phone number is required"),
    requestedConcessionAmount: Yup.string().required("Concession Amount is required"),
    
    // reasonForTransfer: Yup.string().required("Reason for transfer is required"),
    // additionalComments: Yup.string().required("Additional comments are required"),
  });

  
  useEffect(() => {
  const fetchStudentDetails = async () => {
    if (!studentId) return;
    try {
      const response = await fetch(
        `${baseUrl}/api/admission/getAllSpecificStudentsDetails/${studentId}/${oId}`
      );
      if (response.ok) {
        const data = await response.json();
        setInitialValues((prev) => ({
          ...prev,
          studentId: data.studentId || studentId,
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          fathersFirstName: data.fathersFirstName || "",
          fathersLastName: data.fathersLastName || "",
          fathersMailId: data.fathersMailId || "",
          primaryContact: data.primaryContact || "",
          course: data.course || "",
          romanNumberClass: data.romanNumberClass || "",
          sections: data.sections || "",
          tutionFee: data.tutionFee || "",
        }));
        toast.success("Student data loaded", { autoClose: 1000 });
      } else {
        toast.error("Student data not found", { autoClose: 1500 });
      }
    } catch (error) {
      toast.error("Failed to fetch student data", { autoClose: 2000 });
    }
  };

  fetchStudentDetails();
}, [studentId, oId]);



  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        minHeight: '100vh',
        paddingTop: '50px',
      }}
    >
      <Card
        style={{
          marginRight: "20px",
          marginLeft:'20px',
          marginTop:'20px',
          padding: "20px",
          padding: "20px",
          backgroundColor: "#ffffff",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
         
          width: "100%",
        }}
      >
        <CardContent>
<Box display="flex" alignItems="center" sx={{marginBottom:2}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              Student Fee Concession Form
                              </Typography>
                            </Box>

          
          {/* Formik Form */}
          <Formik
              enableReinitialize
              initialValues={initialValues}
            validationSchema={validationSchema}
onSubmit={async (values, { setSubmitting }) => {

  setLoading(true);

  try {
    // build query string
    const params = new URLSearchParams({
      requestedConcessionAmount: values.requestedConcessionAmount,
      studentId: values.studentId,
      rolePayment: "tution_fee"
    });
    const url = `${baseUrl}/api/concession/requestConcession/${oId}?${params}`;

    const response = await fetch(url, { method: "POST" });

    if (!response.ok) {
      // non‑2xx – read body safely and throw
      const errText = await response.text();
      throw new Error(errText || "Server returned an error");
    }

    // success – read the body only if you actually need it
    const data = await response.text();          // or response.json()
    console.log("Success:", data);

    toast.success(data || "Concession Requested to Principal Successfully!", { autoClose: 1000 });
    setTimeout(() => navigate("/StudentFeeConcessionList"), 1100);
  } catch (err) {
    console.error("Submit error:", err);
    toast.error(err.message || "Unexpected error. Please try again.", {
      autoClose: 2000,
    });
  } finally {
    setLoading(false);
    setSubmitting(false);
  }
}}


          
          >
            {({ handleChange, handleBlur, values, errors, touched,setFieldTouched,setFieldValue, setFieldError ,setValues }) => (
              <Form>
                {/* Full Name */}
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    textAlign: 'left',
                  }}
                >
                  Full Name
                </Typography>
                <Grid container spacing={2}>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="First Name"
                        variant="outlined"
                        fullWidth
                        name="firstName"
                        value={values.firstName  || "N/A"}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.firstName && Boolean(errors.firstName)}
                        helperText={touched.firstName && errors.firstName}
                        placeholder="Enter your first name"
                        disabled // Make it non-editable
                        InputProps={{
                          style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'}, // Gray background to indicate non-editable
                        }}
                        InputLabelProps={{
                          shrink: values.firstName ? true : undefined, // Moves label up when value exists
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Last Name"
                        variant="outlined"
                        fullWidth
                        name="lastName"
                        value={values.lastName  || "N/A"}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.lastName && Boolean(errors.lastName)}
                        helperText={touched.lastName && errors.lastName}
                        placeholder="Enter your last name"
                        disabled // Make it non-editable
                        InputProps={{
                          style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'}, // Gray background to indicate non-editable
                        }}
                        InputLabelProps={{
                          shrink: values.lastName ? true : undefined, // Moves label up when value exists
                        }}
                        
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
  <FormControl fullWidth style={{ marginBottom: "20px" }}>
    <Field
      as={TextField}
      label="Father Name"
      variant="outlined"
      fullWidth
      name="fathersFirstName"
      value={`${values.fathersFirstName || ""} ${values.fathersLastName || ""}`.trim()} // Combine First and Last Name
      placeholder="Enter Father's Name"
      disabled // Make it non-editable
      InputProps={{
        style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'}, // Gray background to indicate non-editable
      }}
      InputLabelProps={{
        shrink: values.fathersFirstName || values.fathersLastName ? true : undefined, // Moves label up when value exists
      }}
    />
  </FormControl>
  </Grid>

{(board === "INTERMEDIATE") && (
  <>
   <Grid item xs={12} sm={6}>

  <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Course"
                        variant="outlined"
                        fullWidth
                        name="course"
                        value={values.course}
                        // onChange={handleChange}
                        // onBlur={handleBlur}
                        // error={touched.course && Boolean(errors.course)}
                        // helperText={touched.course && errors.course}
                        placeholder="Enter your last name"
                        disabled // Make it non-editable
                        InputProps={{
                          style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'}, // Gray background to indicate non-editable
                        }}
                        InputLabelProps={{
                          shrink: values.course || values.course ? true : undefined, // Moves label up when value exists
                        }}
                      />
                    </FormControl>
                    </Grid>
                    </>
                    )}


                </Grid>

                {/* Email and Phone Number */}
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    textAlign: 'left',
                  }}
                >
                  Contact Information
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Email Address"
                        variant="outlined"
                        fullWidth
                        name="fathersMailId"
                        value={values.fathersMailId || "N/A"}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.fathersMailId && Boolean(errors.fathersMailId)}
                        helperText={touched.fathersMailId && errors.fathersMailId}
                        placeholder="Enter your email address"
                        disabled // Make it non-editable
                        InputProps={{
                          style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'}, // Gray background to indicate non-editable
                        }}
                        // InputLabelProps={{
                        //   shrink: values.fathersMailId ? true : undefined, // Moves label up when value exists
                        // }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Phone Number"
                        variant="outlined"
                        fullWidth
                        name="primaryContact"
                        value={values.primaryContact}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.primaryContact && Boolean(errors.primaryContact)}
                        helperText={touched.primaryContact && errors.primaryContact}
                        placeholder="Enter your phone number"
                        disabled // Make it non-editable
                        InputProps={{
                          style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'}, // Gray background to indicate non-editable
                        }}
                        InputLabelProps={{
                          shrink: values.primaryContact ? true : undefined, // Moves label up when value exists
                        }}
                      />

                    </FormControl>
                  </Grid>
                </Grid>

                {/* Current School */}
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    textAlign: 'left',
                  }}
                >
                School Information
                </Typography>
                <Grid container spacing={2}>
                  
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Present Class"
                        variant="outlined"
                        fullWidth
                        name="romanNumberClass"
                        value={`${values.romanNumberClass || ""}`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.romanNumberClass && Boolean(errors.romanNumberClass)}
                        helperText={touched.romanNumberClass && errors.romanNumberClass}
                        placeholder="Enter the class"
                        disabled // Make it non-editable
                        InputProps={{
                          style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'}, // Gray background to indicate non-editable
                        }}
                        
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Current Section"
                        variant="outlined"
                        fullWidth
                        name="sections"
                        value={values.sections}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.sections && Boolean(errors.sections)}
                        helperText={touched.sections && errors.sections}
                        placeholder="Enter the Section"
                        disabled // Make it non-editable
                        InputProps={{
                          style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'}, // Gray background to indicate non-editable
                        }}
                        InputLabelProps={{
                          shrink: values.sections ? true : undefined, // Moves label up when value exists
                        }}
                      />
                    </FormControl>
                  </Grid>

                  
            
                </Grid>


                 {/* Current School */}
                <Typography
                  variant="h6"
                  style={{
                    fontWeight: 'bold',
                    marginBottom: '10px',
                    textAlign: 'left',
                  }}
                >
                Tution Fee Concession
                </Typography>
                <Grid container spacing={2}>
                  
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth style={{ marginBottom: '20px' }}>
                      <Field
                        as={TextField}
                        label="Total Tution Fee Amount"
                        variant="outlined"
                        fullWidth
                        name="tutionFee"
                        value={`${values.tutionFee || ""}`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.tutionFee && Boolean(errors.tutionFee)}
                        helperText={touched.tutionFee && errors.tutionFee}
                        placeholder="Enter the class"
                        disabled // Make it non-editable
                        InputProps={{
                          style: { backgroundColor: "#f0f0f0", color: "#6c757d" ,fontWeight:'bold'}, // Gray background to indicate non-editable
                        }}
                        InputLabelProps={{
                                sx: {
                                    fontWeight: "bold",
                                    
                                },
                                }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                                      <FormControl fullWidth style={{ marginBottom: '20px' }}>
                                        <Field
  as={TextField}
  label="Tution Fee Concession Amount"
  variant="outlined"
  type="text"
  fullWidth
  name="requestedConcessionAmount"
  value={values.requestedConcessionAmount}
     onKeyDown={(e) => {
      // Allow only digits and control keys like Backspace, Delete, Arrow keys
      const allowedKeys = [
        "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"
      ];
      if (
        !/^\d$/.test(e.key) && // if not a digit
        !allowedKeys.includes(e.key)
      ) {
        e.preventDefault(); // Block the key press
      }
    }}
  onChange={(e) => {
    const val = e.target.value;
    if (/^\d*$/.test(val)) {
      handleChange(e); // Only allow digits (0–9)
    }
  }}
  onBlur={handleBlur}
  error={touched.requestedConcessionAmount && Boolean(errors.requestedConcessionAmount)}
  helperText={touched.requestedConcessionAmount && errors.requestedConcessionAmount}
  placeholder="Enter Concession Amount"
  inputProps={{
    min: 0,
    inputMode: 'numeric',
    pattern: '[0-9]*',
  }}
/>

                                      </FormControl>
                                    </Grid>

                  
            
                </Grid>

           
             





                




                {/* Submit Button */}
                <div style={{ marginTop: '20px', textAlign: 'right' }}>
  <Button
    variant="contained"
    color="secondary"  // Change the color here (e.g., 'secondary' for a different color)
    type="submit"
    disabled={loading}
    // style={{
    //   padding: '10px 20px',
    //   fontSize: '13px',
    // }}
    sx={{
      backgroundColor: "#3C3972",
      fontWeight:'bold', 
      color: "white",
      "&:hover": {
        backgroundColor: "#3C3972", 
      },
    }}
  >
    {loading ? (
      <CircularProgress size={24} color="inherit" />
    ) : (
      'Submit'
    )}
  </Button>
</div>
              </Form>
            )}
          </Formik>
          <ToastContainer />
        </CardContent>
      </Card>
    </div>
  );
}